import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import pickBy from 'lodash/pickBy';
import { CalendarContainer } from 'react-datepicker';

import RelativeDateInput from './relative_date_input';
import { ApexDatePickerContext } from './context';

export function ApexDateCalendarContainer({
  alignRight,
  dateFields,
  dateValues,
  name,
  value,
  onCancel,
  onChange,
  ...props
}) {
  const selectableDateFields = useMemo(
    () => pickBy(dateFields, (_, dateFieldName) => dateFieldName !== name),
    [dateFields, name]
  );

  return (
    <div
      aria-label="date-picker"
      className={classNames('apex-date-input-calendar-container', { ['align-right']: alignRight })}
    >
      <RelativeDateInput
        dateFields={selectableDateFields}
        dateValues={dateValues}
        value={value}
        onCancel={onCancel}
        onChange={onChange}
      >
        <CalendarContainer {...props} showPopperArrow={false} />
      </RelativeDateInput>
    </div>
  );
}

ApexDateCalendarContainer.propTypes = {
  alignRight: PropTypes.bool,
  dateFields: PropTypes.objectOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
  })),
  dateValues: PropTypes.object.isRequired,
  name: PropTypes.string,
  value: PropTypes.object,
  onCancel: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default function ApexDateCalendarContainerWrapper({ ...props }) {
  return (
    <ApexDatePickerContext.Consumer>
      {({ dateFields, dateValues, name, value, onCancel, onChange }) => {
        return (
          <ApexDateCalendarContainer
            {...props}
            dateFields={dateFields}
            dateValues={dateValues}
            name={name}
            value={value}
            onCancel={onCancel}
            onChange={onChange}
          />
        );
      }}
    </ApexDatePickerContext.Consumer>
  );
}

ApexDateCalendarContainerWrapper.propTypes = {};
